"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputFilesGS = void 0;
const gs = require("..");
const InputGS_1 = require("./InputGS");
class InputFilesGS extends InputGS_1.InputGS {
    constructor(el) {
        super(el);
        this._onFilesSelectedToken = new gs.EventGSToken(() => { el.addEventListener('change', () => this.onChangeHandler()); });
        this.onFilesSelected = new gs.EventGS(this._onFilesSelectedToken);
    }
    static ForHTMLElement(el) {
        if (el.nodeName.toLowerCase() === "input") {
            const inputEl = el;
            return inputEl.type === 'file';
        }
        return false;
    }
    /**
     * Open selectFilesDialog
     * */
    open() {
        this.el.click();
    }
    onChangeHandler() {
        if (this.el.files.length === 0)
            return;
        const list = Array.from(this.el.files);
        this._onFilesSelectedToken.invoke(list);
    }
}
exports.InputFilesGS = InputFilesGS;
gs.WrapperGS.ExtendComponentsByHTMLElement(InputFilesGS);
//# sourceMappingURL=InputFilesGS.js.map